export default __webpack_public_path__ + "static/media/04.75e5edde.jpg";